import React from "react";
import { Link } from "react-router-dom";
import * as CHQ from "chq";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import LazyEditorOutput from "components/editor/LazyEditorOutput";

import NotificationBody from "./NotificationBody";

type FlagProps = {
  flag: CHQ.Flag;
};

const Flag: React.FC<FlagProps> = ({ flag }) => {
  switch (flag.flaggableType) {
    case "Comment":
      return (
        <Trans>
          the comment: <LazyEditorOutput output={flag.flaggable.body} />
        </Trans>
      );
    case "Department":
      return <Trans>the &quot;{flag.flaggable.name}&quot; department</Trans>;
    case "Event":
      return <Trans>the &quot;{flag.flaggable.name}&quot; event</Trans>;
    case "Interest":
      return <Trans>the &quot;{flag.flaggable.name}&quot; interest</Trans>;
    case "Location":
      return <Trans>the &quot;{flag.flaggable.name}&quot; location</Trans>;
    case "Photo":
      return (
        <Trans>
          the photo:
          {" "}
          <img
            className="img-preview"
            src={flag.flaggable.image.mediumUrl}
            alt="thumb"
          />
        </Trans>
      );
    case "Post":
      return (
        <Trans>
          the post: &quot;<LazyEditorOutput output={flag.flaggable.body} />&quot;
        </Trans>
      );
    case "Recognition":
      return (
        <Trans>
          the recognition: &quot;<LazyEditorOutput output={flag.flaggable.body} />&quot;
        </Trans>
      );
    case "User":
      return <Trans>{flag.flaggable.name}&apos;s profile</Trans>;
    default:
      return null;
  }
};

type FlagCreatedNotificationProps = {
  notification: CHQ.NotificationFlagCreated;
  tabIndex?: number;
};

const FlagCreatedNotification: React.FC<FlagCreatedNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <Trans>
      <ProfileLink user={actor} tabIndex={tabIndex || 0} /> has flagged: <Flag flag={entity} />
    </Trans>
    <br />
    <Link to="/admin/flags" tabIndex={tabIndex || 0}>
      <Trans>Review flagged content</Trans>
    </Link>
  </NotificationBody>
);

export default FlagCreatedNotification;
